t = require('views/internal/teacup-with-helpers')('error')
{ ErrorViews } = require 'common/data/error-views'

module.exports = t.renderable ({ isLoggedIn, url, errorType, modelType, email, nextActionUrl, fullName })->
  unconfirmedModel = (messageKey) ->
    t.div '.big-message.with-picture.quiet', ->
      t.img { src: require('images/TacoBouncer.png'), width: '459', height: '238' }

      t.h1 ->
        t.format 'roooooo-are-you'

      t.p ->
        t.format messageKey

      t.div '.callout', ->
        t.ol ->
          t.li ->
            t.format 'check-your-email-at-email', { email }
          t.li ->
            t.format 'look-for-an-email-with-the-subject-trello-account-confirmation'
          t.li ->
            t.format 'click-on-the-confirmation-link-done'

      t.p ->
        t.format 'dont-see-anything-from-us'
        t.raw ' '
        t.a '.quiet.js-resend-confirmation-email', { href: '#' }, ->
          t.format 'resend-confirmation-link'

  normalError = (headerKey, loggedInMessageKey, notLoggedInMessageKey) ->
    link = t.render ->
      t.a '.js-login', { href: '#' }, ->
        t.format 'log-in-link-text'
    t.div '.big-message.quiet', ->
      t.h1 ->
        t.format headerKey

      if !isLoggedIn
        t.p ->
          t.format loggedInMessageKey, { logInLink: link }, { raw: true }
      else
        t.p ->
          t.format notLoggedInMessageKey, { logInLink: link }, { raw: true }

        t.div '.little-message', ->
          t.format 'different-current-user', { currentUserName: fullName }
          t.a { href: "/login?reauthenticate=1&returnUrl=#{ encodeURIComponent(returnUrl) }" }, ->
            t.format 'switch-accounts'
      return

  invitationLinkError = (messageKey) ->
    t.div '.big-message.quiet', ->
      t.h1 ->
        t.format messageKey

      t.p ->
        t.format 'ask-for-a-new-link'

  headingWithLinkError = (messageKey, linkKey, linkHref) ->
    t.div '.big-message.quiet', ->
      t.h1 ->
        t.format messageKey

      t.p ->
        t.a '.quiet', { href: linkHref }, ->
          t.format linkKey

  headingError = (messageKey) ->
    t.div '.big-message.quiet', ->
      t.h1 ->
        t.format messageKey

  returnUrl = window.location.pathname

  switch errorType
    when ErrorViews.NOT_FOUND
      normalError 'page-not-found',
        'this-page-may-be-private-you-may-be-able-to-view-it-by-logging-in',
        'this-page-may-be-private-if-someone-gave-you-this-link-they-may-need-to-invite-you-to-one-of-their-boards-or-organizations'

    when ErrorViews.BOARD_NOT_FOUND
      normalError 'board-not-found',
        'this-board-may-be-private-you-may-be-able-to-view-it-by-logging-in',
        'this-board-may-be-private-if-someone-gave-you-this-link-they-may-need-to-invite-you-to-one-of-their-boards-or-organizations'

    when ErrorViews.CARD_NOT_FOUND
      normalError 'card-not-found',
        'this-card-may-be-on-a-private-board-you-may-be-able-to-view-it-by-logging-in',
        'this-card-may-be-on-a-private-board-if-someone-gave-you-this-link-they-may-need-to-invite-you-to-one-of-their-boards-or-organizations'

    when ErrorViews.BOARD_INVITATION_NOT_FOUND
      invitationLinkError 'board-invitation-not-valid'

    when ErrorViews.ORG_INVITATION_NOT_FOUND
      invitationLinkError 'org-invitation-not-valid'

    when ErrorViews.UNCONFIRMED_ORG_NOT_FOUND
      unconfirmedModel 'please-confirm-your-email-address-to-view-this-org'

    when ErrorViews.UNCONFIRMED_BOARD_NOT_FOUND
      unconfirmedModel 'please-confirm-your-email-address-to-view-this-board'

    when ErrorViews.UNCONFIRMED_ENTERPRISE_NOT_FOUND
      unconfirmedModel 'please-confirm-your-email-address-to-view-this-enterprise'

    else
      t.div '.big-message.quiet', ->
        t.h1 ->
          t.format 'page-not-found'



// WEBPACK FOOTER //
// ./app/scripts/views/templates/error.coffee